var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.personalizedType !== 'clipartCategory' && _vm.isLoadJs)?_c('FormulateInput',{attrs:{"type":"imagescrabble","name":_vm.layer.id,"label":_vm.label,"aspectRatio":_vm.aspectRatio,"configsScrabble":_vm.configsScrabble,",":"","valueDefault":_vm.valueDefault,"width":_vm.width,"height":_vm.height},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var label = ref.label;
var id = ref.id;
return [_c('label',{attrs:{"for":id}},[_vm._v("\n      "+_vm._s(label)+"\n      "),(_vm.required)?_c('strong',{staticStyle:{"color":"#ff7875"}},[_vm._v("*")]):_vm._e()])]}}],null,false,3171466266)}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff23dba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/ImageScrabbleField.vue
// module id = 232
// module chunks = 0